import type { ReactNode } from 'react';

import { isFeatureAvailable, type BackendFeature } from '@/config/features';
import type { ApiMode } from '@/config/runtime';
import FeatureUnavailablePage from '@/pages/FeatureUnavailablePage';

interface FeatureRouteProps {
  apiMode: ApiMode;
  children: ReactNode;
  feature: BackendFeature;
  standalone?: boolean;
}

export default function FeatureRoute({
  apiMode,
  children,
  feature,
  standalone = false,
}: FeatureRouteProps) {
  if (!isFeatureAvailable(feature, apiMode)) {
    return <FeatureUnavailablePage feature={feature} standalone={standalone} />;
  }

  return children;
}
